import React from 'react'
import Button from '../common/Button'
import { makeStyles } from '@mui/styles'
import { Tooltip, Typography } from '@mui/material'
import ConfirmationDialog from '../common/ConfirmationDialog'
import { useState } from 'react'
import { noop } from '../../utils/misc'
import { defaultMuiIconStyles, getDisabledByKey, getFillByKey, mobileIconsByKey } from '../../utils/actionButton'
import { statusLedColors } from '../../utils/ecg'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 30,
  }
}))

const ActionButton = props => {
  const classes = useStyles()
  const {
    action,
    status,
    isFirstRow,
    ecg,
    kind,
  } = props
  const icon = mobileIconsByKey[action.key]
  const fillsByKey = getFillByKey(ecg)
  const disabledByKey = getDisabledByKey(ecg, kind)
  const disabled = disabledByKey[action.key]
  const filled = fillsByKey[action.key]
  let fillColor = filled ? '#486581' : '#E0E0E0'
  const isStatus = action.key === 'status'
  const errorStatus = status === 'red'
  if (isStatus) fillColor = statusLedColors[status]
  const detail = `${ecg.rejected ? 'Rechazado.' : ''} ${ecg.notes || 'Sin notas.'} ${ecg.diagnosis || 'Sin diagnóstico.'}`
  const actionOnClick = e => {
    e.preventDefault()
    e.stopPropagation()
    action.onClick(action, ecg)
  }
  const nonDeleteOnClick = disabled ? noop : actionOnClick
  const isDelete = action.key === 'delete'
  const [openDelete, setOpenDelete] = useState(false)
  const handleClick = isDelete ? () => setOpenDelete(true) : nonDeleteOnClick
  const iconStyles = defaultMuiIconStyles({ fillColor })

  return (
    <div
      className={classes.root}
    >
      {openDelete && (
        <ConfirmationDialog
          open={openDelete}
          onClose={() => setOpenDelete(false)}
          truthyAction={() => {
            action.onClick(action, ecg)
            setOpenDelete(false)
          }}
          truthyActionStyle={{ backgroundColor: '#DD3C48' }}
          setOpen={setOpenDelete}
          title='¿Eliminar estudio?'
          description={`ID: ${ecg.id} - ${ecg.patient.name}`}
        />
      )}
      <Tooltip placement='top' arrow title={!isStatus ? action.displayName : ''}>
        <div>
          {isFirstRow && (
            <div className={classes.header}>
              <Typography
                sx={{
                  fontSize: 12,
                }}
              >
                {action.displayName}
              </Typography>
            </div>
          )}
          <Button
            icon={icon}
            style={{
              backgroundColor: 'white',
              width: 40,
              borderRadius: '20px',
              height: 80,
            }}
            disableElevation
            disabled={disabled}
            iconProps={{
              width: 30,
              fontSize: 'large',
            }}
            tooltip={isStatus && (errorStatus || ecg.rejected)}
            tooltipTitle={detail}
            onClick={openDelete ? noop : handleClick}
            iconStyles={iconStyles}
          >
          </Button>
        </div>
      </Tooltip>
    </div>
  )
}

export default ActionButton
